import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { ReactNode } from 'react';

interface IAlertDialogComponent {
  trigger?: string | ReactNode;
  title: string;
  description: string;
  cancelLabel: string;
  deleteLabel: string | ReactNode;
  onClick?: () => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AlertDialogComponent = ({
  trigger,
  title,
  description,
  cancelLabel,
  deleteLabel,
  onClick,
  open,
  onOpenChange,
}: IAlertDialogComponent) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      {trigger && <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>}

      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel
            className="dark:bg-black dark:hover:bg-opacity-80"
            autoFocus
            onClick={() => onOpenChange(false)}
          >
            {cancelLabel}
          </AlertDialogCancel>

          {typeof deleteLabel === 'string' ? (
            <AlertDialogAction
              className="text-white bg-red-600 hover:bg-red-700"
              onClick={() => {
                onClick?.();
                onOpenChange(false);
              }}
            >
              {deleteLabel}
            </AlertDialogAction>
          ) : (
            deleteLabel
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
